import { createContext } from 'react';

import type { IUseAuth } from './IUseAuth';

export const AuthContext = createContext<IUseAuth>({} as IUseAuth);
